import { useEffect, useRef, useState } from 'react';

import { RestAnimationStyled } from './styled';

import restLottie from 'src/animation/rest-lottie.json';

import clsx from 'clsx';
import lottie from 'lottie-web';

interface RestAnimationProps {
  className?: string;
}

const RestAnimation = ({ className }: RestAnimationProps) => {
  const animationContainer = useRef(null);
  const [update, setUpdate] = useState(false);
  useEffect(() => {
    if (animationContainer.current && !update) {
      lottie.loadAnimation({
        container: animationContainer.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: restLottie,
      });

      setUpdate(true);
    }
  }, [animationContainer.current]);

  return (
    <RestAnimationStyled className={clsx('RestAnimation', className)}>
      <div className="animation" ref={animationContainer}></div>
      <div className="message">
        휴식중 입니다... <br /> 충분한 휴식을 취하세요.
      </div>
    </RestAnimationStyled>
  );
};

export default RestAnimation;
